import Menu from 'antd/es/menu';
import React from 'react';

import { submenu, lastSubmenu } from 'src/app/components/ControlCommands/control-commands.config';

const ControlCommands = () => {
  const { SubMenu } = Menu;

  return (
    <Menu mode="inline">
      <SubMenu style={submenu} key="sub1" title="GAME SPEED">
        <Menu.Item key="11">Option 1</Menu.Item>
        <Menu.Item key="12">Option 2</Menu.Item>
      </SubMenu>
      <SubMenu style={submenu} key="sub2" title="STOP GAME">
        <Menu.Item key="11">Option 1</Menu.Item>
        <Menu.Item key="12">Option 2</Menu.Item>
      </SubMenu>
      <SubMenu style={submenu} key="sub3" title="SIDE RELATIONS">
        <Menu.Item key="11">Option 1</Menu.Item>
        <Menu.Item key="12">Option 2</Menu.Item>
      </SubMenu>
      <SubMenu style={submenu} key="sub4" title="TERRAIN">
        <Menu.Item key="11">Option 1</Menu.Item>
        <Menu.Item key="12">Option 2</Menu.Item>
      </SubMenu>
      <SubMenu style={lastSubmenu} key="sub5" title="CHANGE SUPPLY STATUS">
        <Menu.Item key="11">Option 1</Menu.Item>
        <Menu.Item key="12">Option 2</Menu.Item>
      </SubMenu>
    </Menu>
  );
};

export default ControlCommands;
